/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadInfoRequestState } from './CreateLeadInfoRequestState';
import {
    CreateLeadInfoRequestStateFromJSON,
    CreateLeadInfoRequestStateFromJSONTyped,
    CreateLeadInfoRequestStateToJSON,
} from './CreateLeadInfoRequestState';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
} from './OrganizationStateTown';
import type { OrganizationStateType } from './OrganizationStateType';
import {
    OrganizationStateTypeFromJSON,
    OrganizationStateTypeFromJSONTyped,
    OrganizationStateTypeToJSON,
} from './OrganizationStateType';

/**
 * 
 * @export
 * @interface OrganizationState
 */
export interface OrganizationState {
    /**
     * 
     * @type {string}
     * @memberof OrganizationState
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationState
     */
    state_id?: string;
    /**
     * 
     * @type {OrganizationStateType}
     * @memberof OrganizationState
     */
    type?: OrganizationStateType;
    /**
     * 
     * @type {CreateLeadInfoRequestState}
     * @memberof OrganizationState
     */
    state?: CreateLeadInfoRequestState;
    /**
     * 
     * @type {Array<OrganizationStateTown>}
     * @memberof OrganizationState
     */
    towns?: Array<OrganizationStateTown>;
}

/**
 * Check if a given object implements the OrganizationState interface.
 */
export function instanceOfOrganizationState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrganizationStateFromJSON(json: any): OrganizationState {
    return OrganizationStateFromJSONTyped(json, false);
}

export function OrganizationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'type': !exists(json, 'type') ? undefined : OrganizationStateTypeFromJSON(json['type']),
        'state': !exists(json, 'state') ? undefined : CreateLeadInfoRequestStateFromJSON(json['state']),
        'towns': !exists(json, 'towns') ? undefined : ((json['towns'] as Array<any>).map(OrganizationStateTownFromJSON)),
    };
}

export function OrganizationStateToJSON(value?: OrganizationState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state_id': value.state_id,
        'type': OrganizationStateTypeToJSON(value.type),
        'state': CreateLeadInfoRequestStateToJSON(value.state),
        'towns': value.towns === undefined ? undefined : ((value.towns as Array<any>).map(OrganizationStateTownToJSON)),
    };
}

